module.exports = __webpack_public_path__ + "client/images/034a3deadb1afae10331c80d98953e0d.svg";